// Packages
import { createTheme } from '@mui/material/styles';

const Theme = createTheme({
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '1rem'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: { 
          fontSize: '1rem',
          padding: '10px 20px',
          border: 'none',
          boxShadow: '0px 2px 5px rgba(0,0,0,0)',
          textTransform: 'none',
          '&:hover': {
            boxShadow: 'none',
            border: 'none',
          }
        },
      }
    }
  },
});

export default Theme;
